export const maintenanceWindows = `
  query {
    maintenanceWindows {
      startDatetime
      endDatetime
      maintenanceMessage
    }
  }
`;
